import * as React from "react";
import type { SVGProps } from "react";
const SvgAnglesDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.148 23.23c-.36.36-1.019.36-1.378 0l-9.583-9.583c-.36-.36-.36-1.018 0-1.377.359-.36 1.018-.36 1.377 0l8.925 8.924 8.864-8.924c.36-.36 1.018-.36 1.378 0 .36.359.36 1.018 0 1.377zM21.73 2.148l-9.583 9.583c-.36.36-1.019.36-1.378 0L1.187 2.147c-.36-.36-.36-1.018 0-1.377.359-.36 1.018-.36 1.377 0l8.925 8.924L20.353.77c.36-.36 1.018-.36 1.378 0 .36.359.36 1.018 0 1.377"
    />
  </svg>
);
export default SvgAnglesDown;
